import { createI18n } from 'vue-i18n'

/** English only for now. Add strings here as screens move to `t()`. */
const messages = {
  en: {
    app: {
      title: 'Patient Portal'
    }
  }
}

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  globalInjection: true,
  messages
})

export default i18n
